module.exports = __webpack_public_path__ + "static/media/Promotion_Card_SG.c593ec06.jpg";